import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceLang {
    lookupService = new APIServiceLookUp();

    async getAllLang(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}lang/getAllLang`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getLangOptions(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}lang/getLangOptions`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}